/*
 * @Author: zhang lin
 * @Date:  2022-05-09 14:30:19
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-05-10 19:24:23
 */
import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/supos/platform';

// 获取平台运行状态
export const getSuposStatus = async (params: any) => {
  return request.post(`${basePath}/status`, params);
};

// 操作supos    1:启动  2 停止  3.重启  4.更新配置
export const operationSuposApi = async (params: any) => {
  return request.put(`${basePath}/operate`, params);
};

// 获取平台管理基础信息
export const getBasicInfo = async () => {
  return request.get(`${basePath}/basic`);
};

// 获取supos状态（纯状态和进度）用于中间状态轮循
export const getSuposTaskStatus = async (name: string) => {
  return request.get(`${basePath}/task/${name}`);
};
